export var MAX_PRECISION = 20;
export var COUNTRY_CODE = {
  SG: 'SG',
  ID: 'ID',
  MY: 'MY',
  PH: 'PH',
  TW: 'TW',
  TH: 'TH',
  VN: 'VN',
  IR: 'IR',
  MM: 'MM',
  HK: 'HK',
  BR: 'BR',
  CN: 'CN',
  MX: 'MX',
  CO: 'CO',
  CL: 'CL',
  AR: 'AR',
  PL: 'PL',
  ES: 'ES',
  FR: 'FR',
  IN: 'IN',
  US: 'US',
  KR: 'KR'
};
export var CURRENCY_ID = {
  SGD: 'SGD',
  IDR: 'IDR',
  MYR: 'MYR',
  PHP: 'PHP',
  TWD: 'TWD',
  THB: 'THB',
  VND: 'VND',
  IRR: 'IRR',
  MMK: 'MMK',
  HKD: 'HKD',
  BRL: 'BRL',
  CNY: 'CNY',
  MXN: 'MXN',
  COP: 'COP',
  CLP: 'CLP',
  ARS: 'ARS',
  PLN: 'PLN',
  EUR: 'EUR',
  INR: 'INR',
  USD: 'USD',
  KRW: 'KRW'
};
export var LANGUAGE = {
  en: 'en',
  id: 'id',
  ms: 'ms',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  th: 'th',
  vi: 'vi',
  'pt-BR': 'pt-BR',
  'es-MX': 'es-MX',
  'es-CO': 'es-CO',
  'es-CL': 'es-CL',
  'es-AR': 'es-AR',
  pl: 'pl',
  'es-ES': 'es-ES',
  fr: 'fr',
  hi: 'hi'
};